
import React from "react";
import { Link } from "react-router-dom";
import { useRelatedPosts } from "@/hooks/useRelatedPosts";

interface RelatedPostsProps {
  currentPostId: string;
}

const RelatedPosts: React.FC<RelatedPostsProps> = ({ currentPostId }) => {
  const { posts, isLoading } = useRelatedPosts(currentPostId);
  
  if (isLoading || posts.length === 0) {
    return null;
  }
  
  return (
    <div className="mt-12 mb-8">
      <h2 className="text-2xl font-bold text-hivebubble-slate mb-6">Related Articles</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {posts.map(post => (
          <Link 
            key={post.id} 
            to={`/blog/${post.slug}`}
            className="group block"
          >
            {post.featuredImage && (
              <div className="h-40 rounded-lg overflow-hidden mb-3">
                <img 
                  src={post.featuredImage} 
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>
            )}
            
            <h3 className="font-medium text-hivebubble-slate group-hover:text-hivebubble-coral transition-colors">
              {post.title}
            </h3>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedPosts;
